module.exports = __webpack_public_path__ + "static/media/warning-black.6f03fcbc.svg";